import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

const Toast = styled.aside`
  position: fixed;
  top: max(8px, env(safe-area-inset-top));
  right: 8px;
  z-index: 2147483100;
  width: min(340px, calc(100vw - 16px));
  display: flex;
  border: 1px solid var(--crypto-border-soft);
  border-radius: 8px;
  color: var(--crypto-text, #fff);
  background: var(--crypto-surface, #17202e);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
  button { border: 0; color: inherit; background: transparent; cursor: pointer; }
  .game-notice-open { flex: 1; min-width: 0; padding: 12px; text-align: left; }
  strong { display: block; color: var(--crypto-accent); font-size: 13px; }
  span { display: block; margin-top: 4px; font-size: 12px; }
  .game-notice-dismiss { width: 36px; flex-shrink: 0; align-self: stretch; font-size: 22px; }
`;

// No Dialog, backdrop, focus trap or body lock while the game is interactive.
export const GameNoticeToast = ({ notice, onOpen, onClose }) => {
  const [portalTarget, setPortalTarget] = useState(() => typeof document === "undefined" ? null : document.fullscreenElement || document.webkitFullscreenElement || document.body);
  useEffect(() => {
    const sync = () => setPortalTarget(document.fullscreenElement || document.webkitFullscreenElement || document.body);
    document.addEventListener("fullscreenchange", sync);
    document.addEventListener("webkitfullscreenchange", sync);
    return () => {
      document.removeEventListener("fullscreenchange", sync);
      document.removeEventListener("webkitfullscreenchange", sync);
    };
  }, []);
  if (!notice || typeof document === "undefined") return null;
  return createPortal(
    <Toast aria-label="게임 중 알림" data-game-notice-toast>
      <button type="button" className="game-notice-open" onClick={onOpen}>
        <strong>{notice.title}</strong>
        <span>{notice.message}{notice.count > 1 ? ` (${notice.count}건)` : ""}</span>
        <span>게임 종료 후 확인하기</span>
      </button>
      <button type="button" className="game-notice-dismiss" aria-label="알림 닫기" onClick={onClose}>×</button>
    </Toast>,
    portalTarget || document.body
  );
};
